import { render, staticRenderFns } from "./Format.vue?vue&type=template&id=857124d6"
import script from "./Format.vue?vue&type=script&lang=js"
export * from "./Format.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports